<div class="badge" [ngStyle]="style">
  <span class="badge-text">{{ text }}</span>
</div>
